import {
  accountIdFormat,
  locationIdFormat,
  stationProcessingSessionIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";
import { MongoUserId } from "../../mongo-ids";

/**
 * How an open station processing session ended. `manual` = operator closed it;
 * `daily_sweep` = the end-of-day job that closes open sessions (never sweeps
 * totes). Values mirror the `station_processing_session_close_reason` CRDB enum.
 */
export const StationProcessingSessionCloseReason = {
  manual: "manual",
  dailySweep: "daily_sweep",
} as const;
export type StationProcessingSessionCloseReason =
  (typeof StationProcessingSessionCloseReason)[keyof typeof StationProcessingSessionCloseReason];

export const StationProcessingSessionCloseReasonSchema = z.enum([
  StationProcessingSessionCloseReason.manual,
  StationProcessingSessionCloseReason.dailySweep,
]);

export const StationProcessingSessionRecordSchema = z.object({
  id: stationProcessingSessionIdFormat.schema,
  accountId: accountIdFormat.schema,
  workstationId: z.string(),
  locationId: locationIdFormat.schema,
  legacyUserId: MongoUserId.fromDbBuffer,
  openedAt: z.date(),
  closedAt: z.date().nullable(),
  closeReason: StationProcessingSessionCloseReasonSchema.nullable(),
  deletedAt: z.date().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type StationProcessingSessionRecord = z.infer<
  typeof StationProcessingSessionRecordSchema
>;
